/*
* This class is used to manage slick slider accross the whole website
* */
'use strict';
const gtm = require('./modules/google').tagManager;
const imagesLoaded = require('imagesloaded');
const equalHeight = require('./modules/helpers/equalHeight');
const prepareDeferedImages = require('./modules/helpers/prepareDeferedImages');
const isSmallView = require('./modules/helpers/isSmallView');
const isDesktopView = require('./modules/helpers/isDesktopView');
const isInViewport = require('./modules/helpers/isInViewport');
const debounce = require('./modules/helpers/debounce');
const responsiveBg = require('./responsive-background');
const damHelper = require('./dam/dam-helper');
const advent = require('./advent');
const greenfriday = require('./greenfriday');

let isDragging = false;
let dragStartX = 0;
let dragTarget = '';
let dragOverDot = -1;

const events = {
    onSliderInit : $.Event('slider.onSliderInit'),
    onAfterChange : $.Event('slider.onAfterChange')
};

const SlickControl = function() {
    const def = {
        $slickDefault           : $('.js-slider'),
        sliderIndicatorClass    : '.js-slider-indicator',
        sliderBarClass          : '.js-slider-bar',
        $sliderContentGrid      : $('.js-grid-slider')
    };

    /**
    * Initialize default slick slider
    * There are no special options from here, instead you can define them all from the data attribute in HTML
    */
    this.defaultSlick = function() {
        /* initialize default slick slider */
        if (def.$slickDefault.length > 0) {
            $.each(def.$slickDefault, function(_, el) {
                const $el = $(el);
                const $sliderBar = $el.siblings(def.sliderBarClass) || false;

                prepareDeferedImages(el);
                damHelper.updateImages($el);

                if ($el.hasClass('slick-initialized')) {
                    return true;
                }

                $el.imagesLoaded(function () {
                    // on init prepare and show the slider bar
                    $el.on('init', function(e, slick) {
                        // trigger an event we can hook into from another script
                        $el.trigger(events.onSliderInit, slick);

                        if (slick.slideCount > 1 && $sliderBar !== false) {
                            if (!$el.hasClass('js-product-slider-stacked') || ($el.hasClass('js-product-slider-stacked') && !isSmallView())) {
                                initSliderBar($sliderBar, slick);
                            }
                        } else {
                            // delete slider bar if only 1 slide
                            // helps with animations
                            $el.parent().find(def.sliderBarClass).remove();
                        }
                    });

                    // on beforeChange move the slider indicator to the correct position
                    $el.on('beforeChange', function(e, slick, currentSlide, nextSlide){
                        updateSliderIndicator($sliderBar, slick, nextSlide);
                        const $revealBlock = $sliderBar.closest('.js-reveal');
                        if ($revealBlock && $revealBlock.length) {
                            advent.pushAdventDataLayerDataWithActiveProductImageSlide('reveal content slider');
                        }
                    });

                    $el.on('afterChange', function () {
                        const $element = $('.slick-active').find('.js-banner a.btn');
                        if ($element.length > 0) {
                            gtm.pushNewBannerImpressions($element.attr('data-internal-promotion'));
                        }
                    });

                    const $sliderDots = $el.siblings('.slider-dots');

                    const slickConfig = {
                        arrows: true,
                        appendDots: $sliderDots,
                        dots: true,
                        prevArrow : '<div class="slick-prev"><button type="button" class="btn--stripped icon-arrow3--left slider-button slider-prev"></button></div>',
                        nextArrow : '<div class="slick-next"><button type="button" class="btn--stripped icon-arrow3--right slider-button slider-next"></button></div>',
                        lazyLoad: 'progressive',
                        infinite: false,
                        touchThreshold: 500,
                        speed: 300,
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: false,
                                    fade: $el.hasClass('js-fullwidth-slider-holder')
                                }
                            }
                        ]
                    };

                    if ($el.hasClass('js-sustainability-slider')) {
                        slickConfig.arrows = false;
                        slickConfig.centerMode = true;
                        slickConfig.centerPadding = '20%';
                        slickConfig.variableWidth = true;
                        slickConfig.mobileFirst = true;
                        slickConfig.responsive = [
                            {
                                breakpoint: 1023,
                                settings: 'unslick'
                            }
                        ];
                    }

                    if ($el.hasClass('js-pdp-scrub-slider')) {
                        const sliderPagerEl = document.querySelector('.js-slide-pager');
                        slickConfig.initialSlide = $('.js-pdp-scrub-slider .js-product-thumbnail').index($('.js-pdp-scrub-slider .js-initial'));
                        slickConfig.centerMode = true;
                        slickConfig.centerPadding = '20%';
                        slickConfig.focusOnSelect = true;
                        slickConfig.infinite = true;
                        slickConfig.speed = 1100;
                        slickConfig.cssEase = 'cubic-bezier(0.5, 0, 0, 1)';
                        slickConfig.responsive = [
                            {
                                breakpoint: 768,
                                settings: {
                                    centerPadding: '17.5%'
                                }
                            }, {
                                breakpoint: 1024,
                                settings: {
                                    centerPadding: '27.5%'
                                }
                            }
                        ];

                        $el.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
                            const variantId = $(slick.$slides[nextSlide]).find('[data-variant-id]').data('variantId');
                            const swatch = $('.js-pdp-swatches-image[data-variation-id="' + variantId + '"]');
                            $el.toggleClass('block-zoom', currentSlide !== nextSlide);

                            if (!swatch.length) {
                                return false;
                            }

                            swatch.closest('.js-pdp-swatches-btn').trigger('click.swatch', {skipImage: false, eventLabel: 'pdp_slider_interaction'});
                        });

                        $el.on('afterChange', function(e, slick, currentSlide) {
                            sliderPagerEl.innerText = `${currentSlide + 1} / ${slick.$slides.length}`;
                            $el.trigger(events.onAfterChange, slick);
                        });
                    }

                    if ($el.hasClass('js-pdp-images-slider')) {
                        slickConfig.fade = true;
                        slickConfig.responsive = [
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: true
                                }
                            }
                        ];
                    }

                    if ($el.hasClass('js-fullwidth-slider-holder')) {
                        slickConfig.fade = true;
                    }

                    if ($el.hasClass('js-explanation-slider')) {
                        slickConfig.touchThreshold = 5;
                    }

                    if ($el.hasClass('js-product-slider-stacked') && $el.hasClass('product-main-slider')) {
                        slickConfig.responsive = [
                            {
                                breakpoint: 768,
                                settings: 'unslick'
                            }
                        ];
                    }

                    if ($el.hasClass('infinite-slider')) {
                        slickConfig.infinite = true;
                    }

                    if (!$el.parents('.js-alternative-code-example').length && !$el.hasClass('slick-initialized')) {
                        $el.slick(slickConfig);
                    }

                    if ($el.hasClass('product-main-slider')) {
                        const $sliderParent = $el.closest('.js-product-slider-steps').find('.js-product-slider-media-holder');

                        if ($sliderParent.find('.js-product-slider-image-holder').length) {
                            $sliderParent.find('.js-product-slider-image-holder:first-child').addClass('active');
                            $sliderParent.find('.js-product-slider-image-holder:first-child').lazy();

                            $el.on('afterChange', function(e, slick, currentSlide) {
                                $sliderParent.find('.js-product-slider-image-holder.active').removeClass('active');
                                $sliderParent.find('.js-product-slider-image-holder').eq(currentSlide).addClass('active');
                                $sliderParent.find('.js-product-slider-image-holder.active').lazy();
                                pushActiveSlideToDataLayer(false);
                            });
                        } else if ($sliderParent.find('.js-product-slider-media-single-image').length) {
                            $sliderParent.find('.js-product-slider-media-single-image').addClass('active');
                        }

                        equalHeight($el.find('.step-intro'), $el.find('.step-intro').length);
                    }

                    if ($el.hasClass('js-fullwidth-slider-holder')) {
                        $el.on('beforeChange', function() {
                            $('.js-responsive-bg', $el).each(function (idx, bgEl) {
                                const $bgEl = $(bgEl);

                                if (!$bgEl.attr('style')) {
                                    $bgEl.lazy();
                                }
                            });
                        });
                    }
                });
            });
        }
    };

    /**
     * Initializes the Content Grid Slider
     */
    this.contentGridSlider = function(){
        /* initialize content grid slick slider */
        if (def.$sliderContentGrid.length > 0) {
            $.each(def.$sliderContentGrid, function(i, el) {

                prepareDeferedImages(el);
                damHelper.updateImages(el);

                const $sliderBar = $(el).siblings(def.sliderBarClass);

                if ($(el).hasClass('slick-initialized')) {
                    return true;
                }

                // on init prepare and show the slider bar
                $(el).on('init', function(e, slick){
                    if (slick.slideCount > 1) {
                        initSliderBar($sliderBar, slick);
                    } else {
                        // delete slider bar if only 1 slide
                        // helps with animations
                        $(def.sliderBarClass).remove();
                    }
                });

                // on beforeChange move the slider indicator to the correct position
                $(el).on('beforeChange', function(e, slick, currentSlide, nextSlide){
                    updateSliderIndicator($sliderBar, slick, nextSlide);

                    $('.js-responsive-bg').each(function () {
                        if (!$(this).attr('style')) {
                            $(this).lazy();
                        }
                    });
                });

                if (isSmallView()) {
                    const $sliderDots = $(el).siblings('.slider-dots');

                    $(el).slick({
                        accessibility: true,
                        appendDots: $sliderDots,
                        dots: true,
                        arrows: false,
                        lazyLoad: 'progressive',
                        infinite: false,
                        touchThreshold: 500,
                        mobileFirst: true,
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: 'unslick'
                            }
                        ]
                    });
                }

            });
        }
    };

    /**
     * Initializes the Product List Slider
     */
    this.productListSlider = function() {
        const $sliders = $('.js-product-list-slider');

        $sliders.each(function(i, slider) {
            const $slider = $(slider);
            const $sliderBar = $slider.siblings(def.sliderBarClass);
            const $sliderDots = $slider.siblings('.slider-dots');

            prepareDeferedImages(slider);
            damHelper.updateImages(slider);

            if (isSmallView()) {
                $('.product-list-slider-item.text-item').remove();

                imagesLoaded($slider).on('done', function () {
                    equalHeight($slider.find('.js-product-tile-image').parent());
                });
            }

            $slider.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
                updateSliderIndicator($sliderBar, slick, nextSlide);
            });

            $slider.on('init', function(e, slick) {
                if (slick.$dots) {
                    initSliderBar($sliderBar, slick);
                    bindSliderDragEvents($sliderBar, slick);
                }
            });

            $slider.slick({
                appendDots: $sliderDots,
                arrows: true,
                dots: true,
                draggable: true,
                infinite: false,
                touchThreshold: 500,
                lazyLoad: 'progressive',
                nextArrow : '<div class="slick-next"><button type="button" class="btn--stripped icon-arrow3--right slider-button slider-next"></button></div>',
                prevArrow : '<div class="slick-prev"><button type="button" class="btn--stripped icon-arrow3--left slider-button slider-prev"></button></div>',
                rows: 0,
                slidesToShow: 5.3,
                slidesToScroll: 5,
                speed: 800,
                responsive: [
                    {
                        breakpoint: 1500,
                        settings: {
                            slidesToShow: 4.3,
                            slidesToScroll: 4
                        }
                    },
                    {
                        breakpoint: 1300,
                        settings: {
                            slidesToShow: 3.3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 1100,
                        settings: {
                            slidesToShow: 2.3,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });
    };

    /**
     * Initialize slider bar and indicator under the slider element
     *
     * @param {jQueryObject} $bar jQuery Object referencing the slider bar
     * @param {SlickObject} slick References the selected Slick Slider object
     */
    function initSliderBar($bar, slick) {
        const $indicator = $bar.children(def.sliderIndicatorClass);

        $bar.show();
        $indicator.width(slick.$dots.find('li').width());
    }

    /**
     * Attaches all the necessary events to be able to drag the slider indicator
     *
     * @param {jQueryObject} $bar The jQuery Object to attach the events too
     * @param {SlickObject} slick References the selected Slick Slider object
     */
    function bindSliderDragEvents($bar, slick) {
        const $indicator = $bar.children(def.sliderIndicatorClass);
        const $slick = slick.$slider;

        $indicator.data('slider-width', getTotalSlidesWidth($slick));
        $indicator.on('mousedown', onDragStart);
        $(document).on('mouseup', {$indicator: $indicator}, onDragEndBody);
        $(document).on('mousemove', {$indicator: $indicator}, onDragBody);
    }

    /**
     * Updates the slider indicator after a slide changed
     *
     * @param {jQueryObject} $bar jQuery Object referencing the slider bar
     * @param {SlickObject} slick References the selected Slick Slider object
     * @param {Integer} nextSlide Number of the next slide
     */
    function updateSliderIndicator($bar, slick, nextSlide) {
        // Exit early if we do not have any pager dots
        if (!slick.$dots || slick.$dots.length === 0) {
            return;
        }

        const $sliderBarIndicator = $bar.children(def.sliderIndicatorClass);
        const slidesToShow = slick.options.slidesToShow;
        const leftOfDots = slick.$dots.offset().left;
        const numDots = $('li', slick.$dots).length;

        // If we show more products on one slide, calculate the next pager dot. Otherwise use nextSlide
        const nextDot = (slidesToShow > 1) ? Math.min(Math.max(Math.floor(nextSlide / numDots), 0), numDots - 1) : nextSlide;

        // Grab the left position of the calculated next dot
        const leftOfSlide = slick.$dots.find('li:eq(' + nextDot + ')').offset().left;

        $sliderBarIndicator.css({
            left: leftOfSlide - leftOfDots
        });
    }
};

/**
 * Handles the MouseDown event
 *
 * @param {Event} e MouseDown event
 */
function onDragStart(e) {
    const $self = $(e.currentTarget);

    if ($self.parent().find('.cloned').length === 0) {
        const $clone = $self.clone().addClass('cloned');
        $self.parent().append($clone);
    }

    isDragging = true;
    dragStartX = e.pageX;
    dragTarget = $self;

    $self.addClass('is-dragging');
}

/**
 * Handles the MouseUp event
 *
 * @param {Event} e MouseUp event
 */
function onDragEndBody() {
    if (isDragging) {

        // Grab the correct scrollbar from the global var
        const $self = dragTarget;

        // Grab the correct clone
        const $indicatorClone = $self.siblings('.cloned');

        // Get the pager dot we want to trigger a click event on.
        const $triggerDot = $self.parent().next().find('li:eq(' + dragOverDot + ') button');

        // Reset everything for next drag event
        isDragging = false;
        dragStartX = 0;
        dragTarget = '';
        dragOverDot = -1;

        $self.removeClass('is-dragging');
        $indicatorClone.remove();
        $triggerDot.trigger('click');
    }
}

/**
 * Handles the MouseMove event
 *
 * @param {Event} e MouseMove event
 */
function onDragBody(e) {
    if (isDragging) {
        const $indicator = dragTarget;
        const $indicatorParent = $indicator.parent();
        const $indicatorClone = $indicator.siblings('.cloned');
        const leftClone = $indicatorClone.offset().left - $indicatorParent.offset().left;
        let leftIndicator = e.pageX - dragStartX + leftClone;
        const leftMax = $indicatorParent.width() - $indicator.width();

        // Set horizontal boundries
        leftIndicator = Math.min(Math.max(leftIndicator, 0), leftMax);

        // Move slider indicator
        $indicator.css({
            left: leftIndicator
        });

        updateSliderDots($indicator);
    }
}

/**
 * Updates the Slick Slider currentSlide property with the one that is closest
 * to the indicator
 *
 * @param {jQueryObject} $indicator References the current slide indicator
 */
function updateSliderDots($indicator) {
    const offset = $indicator.parent().offset().left;
    const dots = $indicator.parent().next().find('li');
    const left = $indicator.offset().left;
    const n = dots.length;

    for (let i = 0; i < n; i++) {
        const $el = $(dots[i]);
        const dotCenter = left + offset + ($el.width() / 2);

        // Determine the pager dot the clone is dragged over and store the index
        if (dotCenter >= $el.offset().left && dotCenter <= $el.offset().left + $el.width() && dragOverDot !== i) {
            dragOverDot = i;
            return;
        }
    }
}

/**
 * Calculates the total width of all the visible slides in the slider
 *
 * @param {SlickObject} slick References the selected Slick Slider object
 * @returns {Float} The calculated width
 */
function getTotalSlidesWidth($slick) {
    const items = $slick.find('.product-list-slider-item');
    const n = items.length;
    let width = 0;

    for (let i = 0; i < n; i++) {
        width += $(items[i]).outerWidth(true);
    }

    return width;
}

function pushActiveSlideToDataLayer(checkViewPort) {
    const allSlidesTiles = $('.js-product-main-slider .js-product-tile');

    if (!allSlidesTiles.length) {
        return;
    }

    const pushedClass = 'js-data-layer-list-pushed';
    let productTileToPush = $('.js-product-main-slider .slick-active .js-product-tile:not(.' + pushedClass + ')');

    if (!productTileToPush.length) {
        return;
    }

    productTileToPush = productTileToPush.eq(0);

    if (!checkViewPort || isInViewport(productTileToPush, false)) {
        const datalayerProduct = $('.js-product-tile-datalayer-product', productTileToPush);

        if (datalayerProduct.length > 0) {
            const productData = JSON.parse(datalayerProduct.val());

            if (productData){
                gtm.pushProductTileView(productData);
            }
        }
        productTileToPush.addClass(pushedClass);
    }
}

function zoomedInWindow() {
    if (window.outerWidth > 1024 && !$('body').hasClass('zoomed-in')) {
        $('body').addClass('zoomed-in');
    }
}

function simpleTextBlockSlider() {
    const $sliderSimpleTextBlock = $('.js-text-block-slider');

    $sliderSimpleTextBlock.each(function () {
        const $this = $(this);

        if (!$this.parents('.js-alternative-code-example').length) {
            $this.slick({
                accessibility: true,
                dots: true,
                arrows: false,
                infinite: true,
                mobileFirst: true,
                touchThreshold: 500,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            autoplay: true,
                            speed: 1000,
                            autoplaySpeed: 2000
                        }
                    }
                ]
            });
        }
    });
}

function headerUspSlider() {
    $('.js-header-usp-slider').each(function () {
        $(this).slick({
            accessibility: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2900,
            draggable: false,
            fade: true,
            mobileFirst: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            speed: 500,
            swipe: false,
            touchMove: false
        });
    });
}

function shippinInfoSlider() {
    const $sliderShippingInfo = $('.js-shipping-info-slider');

    $sliderShippingInfo.each(function () {
        const $this = $(this);

        $this.slick({
            accessibility: true,
            dots: true,
            arrows: false,
            infinite: true,
            mobileFirst: true,
            touchThreshold: 500,
            fade: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        autoplay: true,
                        speed: 1000,
                        autoplaySpeed: 2000
                    }
                }
            ]
        });
    });
}

function conceptHighlightBlockSlider() {
    const $conceptHighlightBlock = $('.js-concept-highlight-block-slider');

    if ($(window).width() < 768) {
        $conceptHighlightBlock.each(function () {
            const $this = $(this);

            $this.on('beforeChange', function() {
                advent.pushAdventDataLayerDataWithActiveProductImageSlide('feature slider');
            });

            $this.on('init', function() {
                responsiveBg.init();
            });

            $this.slick({
                accessibility: true,
                dots: true,
                arrows: false,
                infinite: true,
                mobileFirst: true,
                touchThreshold: 500,
                fade: true
            });
        });
    }
}

function writeACardSlider() {
    const $writeACardBlock = $('.js-write-a-card-slider');

    if ($writeACardBlock.hasClass('card-slick-initialized')) {
        return;
    }

    $writeACardBlock.addClass('card-slick-initialized');
    $writeACardBlock.imagesLoaded(function() {
        $writeACardBlock.slick({
            accessibility: true,
            dots: true,
            arrows: false,
            infinite: false,
            mobileFirst: true,
            touchThreshold: 500,
            prevArrow : '<div class="slick-prev"><button type="button" class="icon icon-arrow3--left slider-button slider-prev"></button></div>',
            nextArrow : '<div class="slick-next"><button type="button" class="icon icon-arrow3--right slider-button slider-next"></button></div>',
            lazyLoad: 'progressive',
            speed: 800,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        arrows: true
                    }
                }
            ]
        });
    });
}

function uspSlider() {
    const $uspSlider = $('.js-usp-slider');

    $uspSlider.each(function () {
        const $this = $(this);

        if (!$this.parents('.js-alternative-code-example').length) {
            $this.slick({
                accessibility: true,
                dots: true,
                arrows: false,
                infinite: true,
                mobileFirst: true,
                fade: false,
                touchThreshold: 500,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            autoplay: true,
                            speed: 1000,
                            autoplaySpeed: 4000
                        }
                    }
                ]
            });
        }
    });
}

function tilesSlider() {
    const $threeFilterSlider = $('.js-filter-module-slider');

    $threeFilterSlider.each(function () {
        const $this = $(this);

        $this.slick({
            dots: false,
            arrows: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1.5,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: 'unslick'
                }
            ]
        });
    });
}

function magazineBlockSlider() {
    const $magazineBlockSlider = $('.js-magazine-tile-slider');

    $magazineBlockSlider.each(function () {
        const $this = $(this);

        if ($(window).width() < 768) {
            if (!$this.parents('.js-alternative-code-example').length) {
                $this.slick({
                    accessibility: true,
                    dots: true,
                    arrows: false,
                    infinite: true,
                    touchThreshold: 500,
                    mobileFirst: true,
                    fade: true
                });
            }
        }
    });
}

function twoTileTextBlockSlider() {
    const $twoTileTextBlockSlider = $('.js-two-tile-text-block-slider');

    $twoTileTextBlockSlider.each(function () {
        const $this = $(this);

        if (!$this.parents('.js-alternative-code-example').length) {
            $this.slick({
                accessibility: true,
                arrows: true,
                prevArrow : '<div class="slick-prev"><button type="button" class="btn--stripped icon-arrow3--left slider-button slider-prev"></button></div>',
                nextArrow : '<div class="slick-next"><button type="button" class="btn--stripped icon-arrow3--right slider-button slider-next"></button></div>',
                infinite: false,
                fade: true,
                touchThreshold: 500,
                speed: 800
            });
        }
    });
}

function threeTilesBenefits() {
    const $sliderShippingInfo = $('.js-three-tiles-benefits');

    $sliderShippingInfo.each(function () {
        const $this = $(this);

        if ($(window).width() < 768) {
            $this.slick({
                arrows: false,
                infinite: false,
                centerMode: false,
                slidesToShow: 1.05
            });
        }
    });
}

function giftopenBoxes() {
    $('.js-giftopen-boxes').each(function () {
        $(this).slick({
            arrows: false,
            centerPadding: '10%',
            centerMode: true,
            mobileFirst: true,
            infinite: false,
            responsive: [{
                breakpoint: 769,
                settings: 'unslick'
            }]
        });
    });
}

function timelineComponentSlider() {
    const $timelineComponentBlock = $('.js-timeline-component-slider');

    $timelineComponentBlock.each(function () {
        const $this = $(this);
        const $progressBar = $('.timeline-progress');
        let slidesNum = 0;

        $this.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            if (slick.slideCount === 8) {
                slidesNum = 4;
            } else if (slick.slideCount === 7) {
                slidesNum = 3;
            } else if (slick.slideCount === 6) {
                slidesNum = 2;
            } else if (slick.slideCount === 5) {
                slidesNum = 1;
            }

            const calc = isSmallView() ? (nextSlide / (slick.slideCount - 1)) * 100 : (nextSlide / slidesNum) * 100;
            $progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
        });

        $this.on('init', function(event, slick){
            const slideNum = isSmallView() ? [4,5,6,7] : [1,2,3,4];

            if ($timelineComponentBlock.hasClass('rtl')) {
                if (slick.slideCount === 5) {
                    setTimeout(function () {
                        $('.js-timeline-component-slider').slick('slickGoTo', slideNum[0]);
                    }, 0);
                } else if (slick.slideCount === 6) {
                    setTimeout(function () {
                        $('.js-timeline-component-slider').slick('slickGoTo', slideNum[1]);
                    }, 0);
                } else if (slick.slideCount === 7) {
                    setTimeout(function () {
                        $('.js-timeline-component-slider').slick('slickGoTo', slideNum[2]);
                    }, 0);
                } else if (slick.slideCount === 8) {
                    setTimeout(function () {
                        $('.js-timeline-component-slider').slick('slickGoTo', slideNum[3]);
                    }, 0);
                }
            }
        });

        $this.slick({
            accessibility: true,
            rows: 0,
            draggable: false,
            arrows: true,
            prevArrow : $('.timeline-prev'),
            nextArrow : $('.timeline-next'),
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1250,
                    settings: {
                        slidesToShow: 3.5
                    }
                },
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 950,
                    settings: {
                        slidesToShow: 2.6
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                        draggable: true
                    }
                }
            ]
        });

    });
}

function refillImpactSlider () {
    const $refillImpactSlider = $('.js-refill-impact-slider');

    $refillImpactSlider.each(function () {
        const $this = $(this);
        const $progressBar = $('.refill-impact-progress');

        $this.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            const calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
            $progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
        });

        if ($(window).width() < 768) {
            if (!$this.parents('.js-refill-impact-slider').length) {
                $this.slick({
                    accessibility: true,
                    arrows: true,
                    centerMode: true,
                    dots: false,
                    fade: false,
                    infinite: false,
                    mobileFirst: true,
                    nextArrow : $('.slick-next'),
                    prevArrow : $('.slick-prev'),
                    slidesToShow: 1.3,
                    touchThreshold: 500,
                    variableWidth: true
                });
            }
        }
    });
}

function comparisonBlockSlider () {
    const $comparisonBlockSlider = $('.js-comparison-block');
    const $comparisonLine = $('.advent-comparison-line');

    $comparisonBlockSlider.each(function () {
        const $this = $(this);

        $this.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            if (nextSlide == 0) {
                $comparisonLine.css('left','0%');
            } else if (nextSlide == 1) {
                $comparisonLine.css('left','33.33%');
            } else if (nextSlide == 2) {
                $comparisonLine.css('left','66.66%');
            }
        });

        if ($(window).width() < 1024) {
            if (!$this.parents('.js-comparison-block').length) {
                $this.slick({
                    accessibility: true,
                    arrows: false,
                    centerMode: true,
                    draggable: true,
                    dots: false,
                    fade: false,
                    infinite: false,
                    mobileFirst: true,
                    slidesToShow: 1.3,
                    touchThreshold: 500,
                    variableWidth: true
                });
            }
        }
    });
}

function allAdventGiftsSlider() {
    const $allAdventGiftsSlider = $('.all-advent-gifts-slider');
    const $showSlidePosition = $('.current-position');

    $allAdventGiftsSlider.each(function () {
        const $this = $(this);

        $this.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            const calc = ((nextSlide) / (slick.slideCount)) * 800;
            $showSlidePosition.css('transform', 'translateX(' + calc + '%)');
        });
        if ($(window).width() > 700) {
            $this
                .slick({
                    accessibility: true,
                    arrows: true,
                    draggable: true,
                    prevArrow : '<div class="slick-prev"><button type="button" class="btn--stripped icon-arrow3--left slider-button slider-prev"></button></div>',
                    nextArrow : '<div class="slick-next"><button type="button" class="btn--stripped icon-arrow3--right slider-button slider-next"></button></div>',
                    slidesToShow: 3.25,
                    slidesToScroll: 3,
                    infinite: false,
                    variableWidth: false,
                    responsive: [
                        {
                            breakpoint: 1300,
                            settings: {
                                slidesToShow: 2.25,
                                slidesToScroll: 2
                            }
                        }
                    ]
                });
        }
        if (!isDesktopView()) {
            return;
        } else {
            $('.all-advent-gifts').on('wheel', (function(e) {
                e.preventDefault();

                if (e.originalEvent.deltaY < 0) {
                    $allAdventGiftsSlider.slick('slickPrev');
                } else {
                    $allAdventGiftsSlider.slick('slickNext');
                }
            }));
        }
    });
}

function talismanUspSlider() {
    const $talismanUspSlider = $('.js-talisman-usp-slider');

    $talismanUspSlider.each(function () {
        const $this = $(this);

        if ($(window).width() <= 1024) {
            if (!$this.parents('.js-talisman-usp-slider').length) {
                $this.slick({
                    accessibility: true,
                    autoplay: true,
                    arrows: false,
                    dots: true,
                    draggable: true,
                    infinite: true,
                    mobileFirst: true,
                    slidesToShow: 1,
                    speed: 800,
                    touchThreshold: 500
                });
            }
        }
    });
}

/*
* Initialization
* */
function init() {
    const Slick = new SlickControl();

    initDefaultSlider(Slick);

    if ($('.js-grid-slider').length > 0){
        Slick.contentGridSlider();

        //fix for zoomed in desktop view
        zoomedInWindow();

        $(window).off('resize.slider').on('resize.slider', function () {
            zoomedInWindow();
        });
    }

    if ($('.js-text-block-slider').length > 0) {
        simpleTextBlockSlider();
    }

    if ($('.js-header-usp-slider').length > 0) {
        headerUspSlider();
    }

    if ($('.js-shipping-info-slider').length > 0) {
        shippinInfoSlider();
    }

    if ($('.js-product-list-slider').length > 0) {
        Slick.productListSlider();

        //fix for zoomed in desktop view
        zoomedInWindow();

        $(window).off('resize.slider').on('resize.slider', function () {
            zoomedInWindow();
        });
    }

    if ($('.js-concept-highlight-block').length > 0) {
        conceptHighlightBlockSlider();
    }

    if ($('.js-refill-impact-slider').length > 0) {
        refillImpactSlider();
    }

    if (!$('.js-usp-slider').hasClass('slick-initialized')) {
        uspSlider();
    }

    if ($('.js-filter-module-slider').length > 0) {
        tilesSlider();
    }

    if ($('.js-write-a-card-slider').length > 0) {
        writeACardSlider();
    }

    if (!$('.js-two-tile-text-block-slider').hasClass('slick-initialized')) {
        twoTileTextBlockSlider();
    }

    if (!$('.js-magazine-tile-slider').hasClass('slick-initialized')) {
        magazineBlockSlider();
    }

    if (!$('.js-three-tiles-benefits').hasClass('slick-initialized')) {
        threeTilesBenefits();
    }

    if (!$('.js-giftopen-boxes').hasClass('slick-initialized')) {
        giftopenBoxes();
    }

    if ($('.js-timeline-component-slider').length > 0) {
        timelineComponentSlider();
    }

    if ($('.js-comparison-block').length > 0) {
        comparisonBlockSlider();
    }

    if ($('.all-advent-gifts-slider').length > 0) {
        allAdventGiftsSlider();
    }

    if ($('.js-talisman-usp-slider').length > 0) {
        talismanUspSlider();
    }

    $(window).off('scroll.slickSlider').on('scroll.slickSlider', debounce(function () {
        pushActiveSlideToDataLayer(true);
    }, 300));

    $('.js-explanation-slider .js-add-to-cart, .js-explanation-slider .js-explanation-slider-secondary-button').each(function() {
        const $this = $(this);
        $this.on('click', function() {
            const buttonText = this.innerText.toLowerCase();
            const slider = $(this).parents('.js-explanation-slider')[0];
            const productName = $(slider).find('.js-slider-product-title')[0].innerText;
            greenfriday.pushDataLayerData('homepage', buttonText, productName);
        });
    });
}

const initDefaultSlider = (Slick) => {
    Slick = Slick || new SlickControl();

    if ($('.js-slider').length > 0) {
        Slick.defaultSlick(true);

        // sometimes the PDP slider is init before the images are ready
        // this should reinit the necessary sliders on window load
        if ($('.js-pdp-images-slider, .js-pdp-scrub-slider').length > 0) {
            if (!$('.js-pdp-main').hasClass('giftset-pdp-main-container')) {
                $(window).on('load', function() {
                    pushActiveSlideToDataLayer(true);
                });
            }
        }

        //fix for zoomed in desktop view
        zoomedInWindow();

        $(window).off('resize.slider').on('resize.slider', debounce(function () {
            zoomedInWindow();
        }, 200));
    }
};

module.exports = {
    init: init,
    writeACardSlider: writeACardSlider,
    initDefaultSlider: initDefaultSlider
};
